import File from '../../../api/File';

export const store = async (context, {params}) => {
    return await new File().store(params);
};

export default {
    store,
};



// WEBPACK FOOTER //
// ./src/store/modules/file/actions.js